import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, change, untouch, formValueSelector } from "redux-form";
import { Link } from "react-router";
import _ from "lodash";
import { toastr } from "react-redux-toastr";
import TextField from "../../components/Fields/TextField";
import { TERMO_ACEITE_LIST_LOAD, TERMO_ACEITE_LIST_UNLOAD, LOGOUT } from "../../actions/Constants";
import api from "../../api/apiUtil";
import Title from "../../components/Layout/Title";
import MaskDate from "../../components/Util/MaskDate";
import TextDatePickerField from "../../components/Fields/TextDatePickerField";
import FieldNormalize from "../../components/Normalize/FieldNormalize";
import FieldValidation from "../../components/Validation/FieldValidation";
import SelectField from "../../components/Fields/SelectField";
import RichEditorField from "../../components/Fields/RichEditorField";
import TermoAceiteModal from "../App/TermoAceiteModal";
import MaskCPF from "../../components/Util/MaskCPF";
import Modal from "react-bootstrap4-modal";
import ReactTable from "react-table";
import { fileExcelO } from "react-icons-kit/fa/fileExcelO";
import SvgIcon from "react-icons-kit";
import XLSX from "xlsx/dist/xlsx.mini.min";
import * as FileSaver from "file-saver";

class TermoAceite extends React.Component {
  constructor() {
    super();
    this.state = {
      adicionar: true,
      modalImage: false,
      idEdit: null,
      modalAceites: false,
      aceitesData: [],
      termoSelecionadoId: null,
      termoSelecionadoTitulo: "",
    };
  }

  componentDidMount() {
    this.props.onLoad(Promise.resolve(api.Configuracao.getTermoAceite()));
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  handleOnCancel = () => {
    this.setState({ adicionar: true, idEdit: null });
    this.props.dispatch(change("TermoAceiteForm", "titulo", null));
    this.props.dispatch(untouch("TermoAceiteForm", "titulo"));
    this.props.dispatch(change("TermoAceiteForm", "versao", null));
    this.props.dispatch(untouch("TermoAceiteForm", "versao"));
    this.props.dispatch(change("TermoAceiteForm", "dataVigencia", null));
    this.props.dispatch(untouch("TermoAceiteForm", "dataVigencia"));
    this.props.dispatch(change("TermoAceiteForm", "dataFim", null));
    this.props.dispatch(untouch("TermoAceiteForm", "dataFim"));
    this.props.dispatch(change("TermoAceiteForm", "habilitado", null));
    this.props.dispatch(untouch("TermoAceiteForm", "habilitado"));
    this.props.dispatch(change("TermoAceiteForm", "conteudo", null));
    this.props.dispatch(untouch("TermoAceiteForm", "conteudo"));
  };

  handleOnSelectValueClick = (value) => (ev) => {
    this.setState({ adicionar: false, idEdit: value.id });
    this.props.dispatch(change("TermoAceiteForm", "titulo", value.titulo));
    this.props.dispatch(change("TermoAceiteForm", "versao", value.versao));
    this.props.dispatch(change("TermoAceiteForm", "dataVigencia", MaskDate.TO_BR_DATE(value.dataVigencia)));
    this.props.dispatch(change("TermoAceiteForm", "habilitado", value.habilitado));
    this.props.dispatch(change("TermoAceiteForm", "conteudo", value.conteudo));
    this.HandleScroll();
  };

  formSubmit(values) {
    var props = this.props;
    let params = {
      titulo: values.titulo,
      versao: values.versao,
      conteudo: values.conteudo,
      dataVigencia: MaskDate.TO_DATABASE(values.dataVigencia),
      habilitado: values.habilitado,
      id: this.state.idEdit ? this.state.idEdit : null,
    };

    if (this.state.idEdit) {
      Promise.resolve(api.Configuracao.putTermoAceite(params))
        .then((ret) => {
          toastr.success("Sucesso", "Registro Alterado");
          this.props.onLoad(Promise.resolve(api.Configuracao.getTermoAceite()));
          this.props.reset();
          this.setState({ adicionar: true, idEdit: null });
        })
        .catch(function (resp) {
          if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else if (resp && resp.response && resp.response.body && resp.response.body.message) {
            toastr.warning("Atenção", resp.response.body.message);
          } else {
            toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
          }
        });
    } else {
      Promise.resolve(api.Configuracao.postTermoAceite(params))
        .then((ret) => {
          toastr.success("Sucesso", "Registro Cadastrado");
          this.props.onLoad(Promise.resolve(api.Configuracao.getTermoAceite()));
          this.props.reset();
          this.setState({ adicionar: true });
        })
        .catch(function (resp) {
          if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else {
            toastr.error("Erro", resp.response.body.message);
          }
        });
    }
  }

  HandleScroll() {
    window.scrollTo(0, 0);
  }

  handleShowAceites = (termo) => {
    this.setState({
      termoSelecionadoId: termo.id,
      termoSelecionadoTitulo: termo.titulo,
      modalAceites: true,
      aceitesData: [],
    });

    Promise.resolve(api.Configuracao.getTermoAceites(termo.id))
      .then((response) => {
        this.setState({ aceitesData: response });
      })
      .catch((error) => {
        if (error.message === "Unauthorized" || error.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Erro ao carregar dados dos aceites!");
        }
      });
  };

  handleCloseAceites = () => {
    this.setState({
      modalAceites: false,
      aceitesData: [],
      termoSelecionadoId: null,
      termoSelecionadoTitulo: "",
    });
  };

  exportToCSV = () => {
    var headersExcell = [["Razão Social", "CPF", "Nome", "Perfis", "Data do Aceite"]];

    var DataExcel = this.state.aceitesData.map((row) => {
      return {
        razaoSocial: row.razaoSocial,
        cpf: `${MaskCPF.TO_CPF(row.cpf)}`,
        nome: row.nome,
        perfis: row.perfis,
        dataAceite: `${MaskDate.TO_BR_DATETIME(row.dataAceite)}`,
      };
    });

    var ws = XLSX.utils.aoa_to_sheet(headersExcell);
    XLSX.utils.sheet_add_json(ws, DataExcel, {
      skipHeader: true,
      origin: "A2",
    });

    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Resultado");
    var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), `AceitesTermo-${this.state.termoSelecionadoTitulo}.xlsx`);
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="O último Termo Aceite ativo aparecerá no Dashboard dos clientes das financeiras" />{" "}
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">Termo Aceite</div>
                <div className="panel-body">
                  <form className="form-horizontal" onSubmit={handleSubmit(this.formSubmit.bind(this))}>
                    <div className="row">
                      <div className="col-md-1">
                        <Field name="versao" label="Versão" component={TextField} type="text" required={true} maxlength={150} validate={[FieldValidation.required]} />
                      </div>
                      <div className="col-md-8">
                        <Field name="titulo" label="Título" component={TextField} type="text" required={true} maxlength={150} validate={[FieldValidation.required]} />
                      </div>
                      <div className="col-md-2">
                        <Field
                          name="dataVigencia"
                          label="Data Vigência"
                          type="text"
                          required={true}
                          placeholder="00/00/0000"
                          component={TextDatePickerField}
                          validate={[FieldValidation.date, FieldValidation.required]}
                          normalize={FieldNormalize.DATE}
                        />
                      </div>
                      <div className="col-md-1">
                        <Field
                          name="habilitado"
                          label="Habilitado"
                          data={[
                            { id: "0", name: "Não" },
                            { id: "1", name: "Sim" },
                          ]}
                          component={SelectField}
                          type="text"
                          valueField="id"
                          textField="name"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <Field name="conteudo" label="Descrição" component={RichEditorField} required={true} validate={[FieldValidation.required]} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-right">
                          {this.props.selectedDesc && this.props.selectedDesc.length > 0 && this.props.selectedTitulo && this.props.selectedTitulo.length > 0 && (
                            <button py-2 type="button" className="btn btn-success" onClick={() => this.setState({ modalImage: true })}>
                              Preview
                            </button>
                          )}
                          <Link className="btn btn-default" to="/alias/termoAceite" onClick={this.handleOnCancel}>
                            {" "}
                            Cancelar
                          </Link>
                          {this.state.adicionar && this.props.currentUser.funcionalidades.includes(99) && (
                            <button className="btn btn-info" onClick={handleSubmit(this.formSubmit.bind(this))}>
                              {"Adicionar"}
                            </button>
                          )}
                          {!this.state.adicionar && this.props.currentUser.funcionalidades.includes(100) && (
                            <button className="btn btn-info" onClick={handleSubmit(this.formSubmit.bind(this))}>
                              {"Alterar"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <div className="panel-tools"></div>
                  Termos cadastrados
                </div>
                <div className="panel-body">
                  <div className="table-responsive">
                    {this.props.all && this.props.all.length > 0 ? (
                      <table cellPadding="1" cellSpacing="1" className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th className="text-center align-middle" style={{ width: "5%" }}>
                              Versão
                            </th>
                            <th className="text-center align-middle">Título</th>

                            <th className="text-center align-middle" style={{ width: "10%" }}>
                              Data Vigência
                            </th>
                            <th className="text-center align-middle" style={{ width: "7%" }}>
                              Habilitado
                            </th>
                            <th className="text-center align-middle" style={{ width: "20%" }}>
                              Ações
                            </th>
                          </tr>
                        </thead>
                        <tbody>{this.renderNewsList()}</tbody>
                      </table>
                    ) : (
                      <small>Nenhum registro encontrado</small>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TermoAceiteModal
          visible={this.state.modalImage}
          titulo={this.props.selectedTitulo}
          conteudo={this.props.selectedDesc}
          onClose={() => this.setState({ modalImage: false })}
          showAcceptButton={true}
          acceptButtonText="Li e Aceito os Termos"
          acceptButtonDisabled={true}
          onAccept={() => {
            console.log("Termo aceito");
          }}
        />
        <Modal visible={this.state.modalAceites} dialogClassName="modal-max-width-75 modal-dialog-tall">
          <div className="modal-header" style={{ padding: "15px", position: "relative" }}>
            <div style={{ width: "100%", textAlign: "center" }}>
              <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                Aceites do Termo: {this.state.termoSelecionadoTitulo}
              </h5>
            </div>
            <button
              type="button"
              className="close"
              style={{
                position: "absolute",
                right: "15px",
                top: "15px",
                background: "transparent",
                border: "none",
                fontSize: "1.5rem",
                fontWeight: "700",
                lineHeight: "1",
                color: "#000",
                opacity: "0.5",
                cursor: "pointer",
              }}
              onClick={this.handleCloseAceites}
            >
              <span>&times;</span>
            </button>
          </div>

          <div className="modal-body" style={{ height: "70vh", padding: "20px" }}>
            <div className="stats-icon float-right">
              <Link className="btn btn-default btn-sm" onClick={() => this.exportToCSV()} title="Gerar XLS">
                {" "}
                <SvgIcon icon={fileExcelO} />
              </Link>
            </div>
            <div className="table-responsive">
              <ReactTable
                className="-striped -highlight"
                defaultPageSize={15}
                data={this.state.aceitesData}
                loadingText="Carregando..."
                noDataText="Nenhum Registro encontrado"
                rowsText="linhas"
                showPageSizeOptions={false}
                minRows={1}
                showPagination={true}
                previousText="Anterior"
                nextText="Próximo"
                pageText="página"
                ofText="de"
                columns={[
                  {
                    Header: "Razão Social",
                    accessor: "razaoSocial",
                    className: "align-middle text-center",
                    headerClassName: "font-extra-bold",
                    filterable: true,
                    filterMethod: (filter, row) => row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
                  },
                  {
                    Header: "CPF",
                    accessor: "rowCPF",
                    className: "align-middle text-center",
                    headerClassName: "font-extra-bold",
                    width: 180,
                    Cell: (rowCPF) => {
                      return (
                        <div>
                          <span>{MaskCPF.TO_CPF(rowCPF.original.cpf)}</span>
                          <br />
                        </div>
                      );
                    },
                  },
                  {
                    Header: "Nome",
                    accessor: "nome",
                    className: "align-middle text-center",
                    headerClassName: "font-extra-bold",
                  },
                  {
                    Header: "Perfis",
                    accessor: "perfis",
                    className: "align-middle text-center",
                    headerClassName: "font-extra-bold",
                  },
                  {
                    Header: "Data do Aceite",
                    accessor: "rowData",
                    className: "align-middle text-center",
                    headerClassName: "font-extra-bold",
                    width: 180,
                    Cell: (rowData) => {
                      return (
                        <div>
                          <span>{MaskDate.TO_BR_DATETIME(rowData.original.dataAceite)}</span>
                          <br />
                        </div>
                      );
                    },
                  },
                ]}
              />
            </div>
          </div>

          <div
            className="modal-footer"
            style={{
              padding: "15px",
              borderTop: "1px solid #dee2e6",
              position: "fixed",
              bottom: "0",
              width: "100%",
              background: "#fff",
              zIndex: "10",
            }}
          >
            <button type="button" className="btn btn-secondary" onClick={this.handleCloseAceites}>
              Fechar
            </button>
          </div>
        </Modal>
      </div>
    );
  }

  renderNewsList() {
    if (!this.props.all) {
      return null;
    }
    return this.props.all.map((item, index) => {
      return (
        <tr key={index}>
          <td className="text-center align-middle">{item.versao}</td>
          <td className="text-center align-middle">{item.titulo}</td>
          <td className="text-center align-middle">{MaskDate.TO_BR_DATE(item.dataVigencia)}</td>
          <td className="text-center align-middle">{item.habilitado ? "Sim" : "Não"}</td>
          <td className="align-middle text-center">
            <div className="btn-group">
              <div>
                {this.props.currentUser.funcionalidades.includes(100) && (
                  <button type="button" className="btn btn-sm btn-default" onClick={this.handleOnSelectValueClick(item)}>
                    <i className="far fa-edit" title="Editar"></i>Editar
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-sm btn-default"
                  disabled={!item.jaAceito}
                  onClick={() =>
                    this.handleShowAceites({
                      id: item.id,
                      titulo: item.titulo,
                    })
                  }
                >
                  <i className="fas fa-search"></i>
                  Exibir Aceites
                </button>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }
}

const mapDispatchToProps = (dispatch) => ({
  onLoad: (payload) => dispatch({ type: TERMO_ACEITE_LIST_LOAD, payload }),
  onUnload: (payload) => dispatch({ type: TERMO_ACEITE_LIST_UNLOAD, payload }),
  onLogout: () => dispatch({ type: LOGOUT }),
});

const selector = formValueSelector("TermoAceiteForm");
const mapStateToProps = (state) => ({
  ...state.termoAceite,
  currentUser: state.common.currentUser,
  selectedDesc: selector(state, "conteudo"),
  selectedTitulo: selector(state, "titulo"),
});

const form = reduxForm({
  form: "TermoAceiteForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(TermoAceite));
